/*
 * Heading emphasis -- geometry + reveal.
 * The inline snippet (snippets/eln-heading-emphasis.liquid) has already
 * wrapped each marked word in <span class="eh">; this file draws the mark
 * at the word's measured pixel size and plays it when it scrolls into view.
 * Config comes from window.ElnEh.cfg.
 */
(function () {
  var E = window.ElnEh;
  if (!E || !E.cfg) return;
  var C = E.cfg, NS = 'http://www.w3.org/2000/svg', uid = 0;
  var RTL = /[֐-ࣿיִ-﷿ﹰ-﻿]/;

  function el(n, a) { var e = document.createElementNS(NS, n); for (var k in a) e.setAttribute(k, a[k]); return e; }
  function R(v) { return Math.round(v * 100) / 100; }
  function narrow() { return window.matchMedia('(max-width: 749px)').matches; }

  /* Four-point star, radius r, centred on 0,0 */
  function star(r) {
    var k = R(r * 0.16), m = R(-r), p = R(r);
    return 'M0 ' + m + 'C' + k + ' ' + -k + ' ' + k + ' ' + -k + ' ' + p + ' 0C' + k + ' ' + k + ' ' + k + ' ' + k + ' 0 ' + p +
           'C' + -k + ' ' + k + ' ' + -k + ' ' + k + ' ' + m + ' 0C' + -k + ' ' + -k + ' ' + -k + ' ' + -k + ' 0 ' + m + 'Z';
  }
  function stops(g, list) {
    list.forEach(function (s) {
      var st = el('stop', { offset: s[0] });
      st.style.cssText = 'stop-color:' + s[1] + ';stop-opacity:' + (s[2] == null ? 1 : s[2]);
      g.appendChild(st);
    });
    return g;
  }
  function lin(defs, id, x1, x2, list) {
    defs.appendChild(stops(el('linearGradient', { id: id, gradientUnits: 'userSpaceOnUse', x1: x1, y1: 0, x2: x2, y2: 0 }), list));
  }
  function rad(defs, id, list) { defs.appendChild(stops(el('radialGradient', { id: id }), list)); }

  function sparks(svg, list, t0) {
    if (!C.sparkles) return;
    list.forEach(function (p, i) {
      var g = el('g', { transform: 'translate(' + R(p[0]) + ' ' + R(p[1]) + ')' });
      var s = el('path', { 'class': 'eh__spark', d: star(p[2]) });
      s.style.cssText = '--sd:' + Math.round(t0 + i * 130) + 'ms;--td:' + (2.5 + i * 1.7).toFixed(1) + 's';
      g.appendChild(s); svg.appendChild(g);
    });
  }

  /* A brush swash: a gentle arc whose thickness swells in the middle and
     tapers to a point at both ends. Built as a polygon from a sampled
     centreline, so no DOM measuring is needed. */
  function swash(W, H, peak) {
    var N = 56, top = [], bot = [], i, t, x, yc, hw;
    for (i = 0; i <= N; i++) {
      t = i / N; x = W * t;
      yc = H * (0.54 - 0.16 * Math.sin(Math.PI * (t * 1.08 - 0.04)) + 0.05 * Math.sin(2 * Math.PI * t));
      hw = peak * (0.16 + 0.84 * Math.pow(Math.sin(Math.PI * t), 0.7));
      top.push(R(x) + ' ' + R(yc - hw)); bot.push(R(x) + ' ' + R(yc + hw));
    }
    return 'M' + top.join('L') + 'L' + bot.reverse().join('L') + 'Z';
  }

  /* All layout reads live here, so a batch can read every word first and
     only then write every SVG. Reading and writing in turns made the browser
     recompute layout once per heading, which is what showed up as a long
     task and a forced reflow on slow phones. */
  function measure(sp) {
    return { w: sp.offsetWidth, h: sp.offsetHeight, fs: parseFloat(getComputedStyle(sp).fontSize) || 16 };
  }

  function build(sp, m) {
    m = m || measure(sp);
    var old = sp.querySelector('.eh__fx');
    if (old) sp.removeChild(old);
    var w = m.w, h = m.h;
    if (w < 8 || h < 5) return false;                       /* not laid out yet */
    var fs = m.fs;
    var px = fs * C.padX / 100 * 2, py = fs * C.padY / 100 * 0.25, nd = fs * C.nudge / 100 * 0.5;
    var sw = narrow() ? C.weightM : C.weight;
    var id = 'eh' + (++uid), st = C.style, t0 = C.delay + C.dur * 0.78;
    var svg = el('svg', { 'class': 'eh__fx', 'aria-hidden': 'true', focusable: 'false' });
    var defs = el('defs'); svg.appendChild(defs);
    var W, H, X, Y;

    if (st === 'halo') {
      /* Two hairline rings: a fuller inner one and a faint outer echo that
         draws slightly later, so the mark has depth instead of reading as a
         flat outline. */
      var g = fs * 0.07;
      W = w + px * 2 + g * 2; H = h + py * 2 + g * 2; X = -px - g; Y = -py - g + nd;
      var cx = R(W / 2);
      function ring(ins) {
        var rr = Math.min((H - ins * 2) / 2, (W - ins * 2) / 2);
        var L = ins, T = ins, Rt = W - ins, B = H - ins;
        var A = ' ' + R(rr) + ' ' + R(rr) + ' 0 0 ';
        var right = 'M' + cx + ' ' + T + 'H' + R(Rt - rr) + 'A' + A + '1 ' + R(Rt) + ' ' + R(T + rr) + 'V' + R(B - rr) + 'A' + A + '1 ' + R(Rt - rr) + ' ' + R(B) + 'H' + cx;
        var left = 'M' + cx + ' ' + T + 'H' + R(L + rr) + 'A' + A + '0 ' + L + ' ' + R(T + rr) + 'V' + R(B - rr) + 'A' + A + '0 ' + R(L + rr) + ' ' + R(B) + 'H' + cx;
        var full = right + 'H' + R(L + rr) + 'A' + A + '1 ' + L + ' ' + R(B - rr) + 'V' + R(T + rr) + 'A' + A + '1 ' + R(L + rr) + ' ' + T + 'Z';
        return { right: right, left: left, full: full, rr: rr, L: L, T: T, Rt: Rt, B: B };
      }
      function stroke(r, cls, width) {
        [r.right, r.left].forEach(function (d) {
          svg.appendChild(el('path', { 'class': cls, d: d, pathLength: 1, stroke: 'url(#' + id + 'g)', 'stroke-width': width }));
        });
      }
      lin(defs, id + 'g', 0, W, [[0, 'var(--eh-c2)'], [0.28, 'var(--eh-c1)'], [0.72, 'var(--eh-c1)'], [1, 'var(--eh-c2)']]);
      rad(defs, id + 'w', [[0, 'var(--eh-c2)', 0.22], [0.7, 'var(--eh-c1)', 0.05], [1, 'var(--eh-c1)', 0]]);
      var outer = ring(sw * 0.25 + 0.5), inner = ring(g + sw / 2 + 1);
      svg.appendChild(el('rect', { 'class': 'eh__wash', x: inner.L, y: inner.T, width: R(inner.Rt - inner.L), height: R(inner.B - inner.T), rx: R(inner.rr), fill: 'url(#' + id + 'w)' }));
      stroke(outer, 'eh__ring eh__ring2', R(sw * 0.5));
      stroke(inner, 'eh__ring', sw);
      var orbit = el('path', { 'class': 'eh__orbit', d: inner.full, pathLength: 1, 'stroke-width': R(sw * 1.6), 'stroke-dasharray': '0.07 0.93' });
      orbit.style.stroke = 'var(--eh-sheen)';
      svg.appendChild(orbit);
      sparks(svg, [[inner.Rt - inner.rr * 0.45, outer.T, fs * 0.3], [inner.L + inner.rr * 0.4, outer.B, fs * 0.2], [outer.Rt, inner.T + (inner.B - inner.T) * 0.62, fs * 0.11]], t0);

    } else if (st === 'underline') {
      W = w + px * 1.2; H = fs * 0.46; X = -px * 0.6; Y = h - fs * 0.18 + nd;
      lin(defs, id + 'g', 0, W, [[0, 'var(--eh-c1)'], [0.55, 'var(--eh-c2)'], [1, 'var(--eh-c1)']]);
      var d = swash(W, H, Math.max(sw * 1.5, fs * 0.045));
      svg.appendChild(el('path', { d: d, fill: 'url(#' + id + 'g)' }));
      var cp = el('clipPath', { id: id + 'c' }); cp.appendChild(el('path', { d: d })); defs.appendChild(cp);
      var gw = W * 0.3;
      lin(defs, id + 's', -gw, 0, [[0, 'var(--eh-sheen)', 0], [0.5, 'var(--eh-sheen)', 0.95], [1, 'var(--eh-sheen)', 0]]);
      var gl = el('rect', { 'class': 'eh__glint', x: R(-gw), y: 0, width: R(gw), height: R(H), fill: 'url(#' + id + 's)', 'clip-path': 'url(#' + id + 'c)' });
      gl.style.setProperty('--gx', R(W + gw) + 'px');
      svg.appendChild(gl);

    } else if (st === 'highlight') {
      W = w + px; H = h * 0.5; X = -px / 2; Y = h * 0.46 + nd;
      var sk = H * 0.28;
      lin(defs, id + 'g', 0, W, [[0, 'var(--eh-c2)', 0.5], [1, 'var(--eh-c2)', 0.3]]);
      svg.appendChild(el('path', {
        d: 'M' + R(sk) + ' 1Q' + R(W / 2) + ' -2 ' + R(W) + ' 2L' + R(W - sk) + ' ' + R(H - 1) + 'Q' + R(W / 2) + ' ' + R(H + 2) + ' 0 ' + R(H - 2) + 'Z',
        fill: 'url(#' + id + 'g)'
      }));

    } else {                                                /* aura */
      W = w + px * 2.6; H = h + py * 4; X = -px * 1.3; Y = -py * 2 + nd;
      rad(defs, id + 'w', [[0, 'var(--eh-c2)', 0.42], [0.55, 'var(--eh-c2)', 0.14], [1, 'var(--eh-c1)', 0]]);
      svg.appendChild(el('ellipse', { 'class': 'eh__wash', cx: R(W / 2), cy: R(H / 2), rx: R(W / 2), ry: R(H / 2), fill: 'url(#' + id + 'w)' }));
      sparks(svg, [[W * 0.86, H * 0.2, fs * 0.3], [W * 0.1, H * 0.74, fs * 0.2], [W * 0.62, H * 0.9, fs * 0.12]], t0);
    }

    svg.setAttribute('viewBox', '0 0 ' + R(W) + ' ' + R(H));
    svg.style.cssText = 'left:' + R(X) + 'px;top:' + R(Y) + 'px;width:' + R(W) + 'px;height:' + R(H) + 'px';
    sp.appendChild(svg);
    return true;
  }

  /* ---- Reveal ----------------------------------------------------------
     --in  : the mark has been drawn (set once, on first sight).
     --live: the word is on screen right now. Idle loops only run while it
             is, so nothing animates (or costs battery) off screen. */
  var all = [];
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = null;

  function ensure(sp, m) {
    if (sp.dataset.ehB) return true;
    if (build(sp, m)) { sp.dataset.ehB = '1'; return true; }
    return false;
  }

  /* Words that are not being animated are drawn in one batch, off the
     load-critical path: every measurement first, then every write. */
  var pending = [], queued = false;
  function drawBatch() {
    queued = false;
    var list = pending; pending = [];
    var ms = list.map(measure);
    for (var i = 0; i < list.length; i++) {
      ensure(list[i], ms[i]);
      list[i].classList.add('eh--in');
    }
  }
  function schedule(sp) {
    pending.push(sp);
    if (queued) return;
    queued = true;
    (window.requestIdleCallback || function (f) { return setTimeout(f, 60); })(drawBatch, { timeout: 800 });
  }

  function watch(sp) {
    all.push(sp);
    /* Direction is a text test, not a layout read, so it stays immediate. */
    if (RTL.test(sp.textContent)) sp.classList.add('eh--rtl');
    if (calm || !C.animate || !('IntersectionObserver' in window)) {
      schedule(sp);
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var s = en.target;
          if (en.isIntersecting) {
            ensure(s);                          /* hidden at boot? built now */
            s.classList.add('eh--in', 'eh--live');
          } else {
            s.classList.remove('eh--live');
          }
        });
      }, { threshold: 0.5, rootMargin: '0px 0px -8% 0px' });
    }
    /* Drawn the first time it nears the screen, not at load: nothing is
       visible until then, and 9 headings no longer all measure at once. */
    io.observe(sp);
  }

  function init(root) {
    var list = (root || document).querySelectorAll('.eh');
    for (var i = 0; i < list.length; i++) {
      if (all.indexOf(list[i]) === -1) watch(list[i]);
    }
  }

  /* The geometry is pixel-exact, so anything that changes the word's size
     (a resize, or the web font arriving) needs a rebuild. */
  function rebuildAll() {
    all = all.filter(function (s) { return document.contains(s); });
    var built = all.filter(function (s) { return s.dataset.ehB; });
    var ms = built.map(measure);                           /* read everything first */
    built.forEach(function (s, i) { build(s, ms[i]); });   /* then write */
  }
  var rt = null;
  window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(rebuildAll, 180); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(rebuildAll);

  document.addEventListener('shopify:section:load', function (e) {
    setTimeout(function () { E.mark(e.target); init(e.target); }, 0);
  });

  init();
})();
